// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2611":"5723e9ad","3475":"9746f54d"}[chunkId] + ".chunk.css";
};